import React from 'react';
import { Tooltip } from 'antd';
import type { FormField } from '../../../types/templates';

type TooltipShape = Pick<FormField, 'tooltipImage'> & { tooltip?: string; tooltipImageLink?: string };

interface CustomTooltipProps {
  field: TooltipShape;
  children: React.ReactElement;
}

export const CustomTooltip: React.FC<CustomTooltipProps> = ({ field, children }) => {
  const tooltipContent = field.tooltipImage ? (
    <div style={{ position: 'relative' }}>
      <img
        src={field.tooltipImage}
        alt='Ejemplo'
        style={{ maxWidth: 200, maxHeight: 200, display: 'block', objectFit: 'contain' }}
      />
    </div>
  ) : field.tooltipImageLink ? (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
      {field.tooltip && <span>{field.tooltip}</span>}
      <a
        href={field.tooltipImageLink}
        target='_blank'
        rel='noreferrer'
        onClick={e => e.stopPropagation()}
        style={{ color: 'white', textDecoration: 'underline' }}
      >
        Imagen de referencia
      </a>
    </div>
  ) : (
    field.tooltip
  );

  return (
    <Tooltip title={tooltipContent} placement='topRight' mouseEnterDelay={0.6}>
      {children}
    </Tooltip>
  );
};
